(function() {
    'use strict';
    angular
        .module('gwApp')
        .factory('ApiSetting', ApiSetting);

    ApiSetting.$inject = ['$resource'];

    function ApiSetting ($resource) {
        var resourceUrl =  'api/api-settings/:path/:id';

        return $resource(resourceUrl, {}, {
            'query': {
                method: 'GET',
                isArray: true,
                params: {
                    path: 'page'
                }
                },
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'delete':{method:'DELETE'},
            'add': { method:'POST'} ,
            'update': { method:'PUT'},
            'detail': {method:'GET'}
        });
    }
})();
